/**
 * [INPUT]: 依赖 vendored dither-kit 极坐标引擎、framer-motion 的 reduced-motion 状态与 motion/CHART_MOTION
 * [OUTPUT]: 对外提供 PieChart、RadarChart 及 Pie/Radar/Legend/Tooltip 组合部件
 * [POS]: zinnercms-design-system/charts 的极坐标产品门面，负责饼/环/雷达图的统一动画、bloom、主题重播与可访问性
 * [PROTOCOL]: 变更时更新此头部，然后检查 AGENTS.md
 */
import { Legend } from '@/zinnercms-design-system/dither-kit/legend'
import { PieChart as DitherPieChart } from '@/zinnercms-design-system/dither-kit/pie-chart'
import { Pie } from '@/zinnercms-design-system/dither-kit/pie'
import { RadarChart as DitherRadarChart } from '@/zinnercms-design-system/dither-kit/radar-chart'
import { Radar } from '@/zinnercms-design-system/dither-kit/radar'
import { RadarFrame } from '@/zinnercms-design-system/dither-kit/radar-frame'
import { Tooltip } from '@/zinnercms-design-system/dither-kit/tooltip'
import { useDitherMotion } from './use-dither-motion'

function PieChart({ replayToken, animate, animationDuration, bloom, bloomOnHover, ...props }) {
  const motion = useDitherMotion(replayToken, { animate, animationDuration, bloom, bloomOnHover })
  return <DitherPieChart {...motion} {...props} />
}

function RadarChart({ replayToken, animate, animationDuration, bloom, bloomOnHover, ...props }) {
  const motion = useDitherMotion(replayToken, { animate, animationDuration, bloom, bloomOnHover })
  return <DitherRadarChart {...motion} {...props} />
}

export { Legend, Pie, PieChart, Radar, RadarChart, RadarFrame, Tooltip }
